module.exports = __webpack_public_path__ + "img/acrobat.19dc649.svg";